import React from 'react'
import { inject, observer } from 'mobx-react'
import { Route, withRouter } from 'react-router-dom'
import { Spin } from 'antd'
import SubscriptionAlertAfterLogin from '../../components/SubscriptionAlertAfterLogin/SubscriptionAlertAfterLogin'

import { COOKIE_STOAGE } from '../../Utils/Storage'
import { COOKIE_SET_TIMER } from '../../Utils/constants'

import {
  ROLE_TYPE,
  ONBOARDING_WIZARD,
  PORTAL_RESTRICTION,
  SUBSCRIPTION_PLAN_STATUS,
} from '../../Utils/constants'
import { checkBoolean } from '../../Utils/helpers'
import { routes } from '../../routes'
import { generateUserMetaIntoObject } from '../../Utils/rules'

@inject('permissionStore', 'loginStore')
@observer
class PermissionWrapper extends React.Component {
  state = {
    loadedSuccessfully: true,
    closeCount: 0,
  }

  render() {
    const { loadedSuccessfully = true } = this.state
    const { permissionStore = {}, loginStore = {} } = this.props || {}

    const {
      permissions = undefined,
      currentOrg = undefined,
      permissionsLoader = false,
      adminRole = [],
      usageLimit = [],
      planPermission = undefined,
    } = permissionStore || {}
    const { user = {} } = loginStore || {}
    const isCustomerUser = user?.role?.isCustomerRole
    let { userMeta = [] } = user || {}
    userMeta = generateUserMetaIntoObject(userMeta)
    const isUser = userMeta.roleId

    const haveGrantPermission =
      isUser === ROLE_TYPE.SUPER_ADMIN || isUser === adminRole[0]
    let isSuperUser = COOKIE_STOAGE.getItem('isSuperUser')
    isSuperUser = checkBoolean(isSuperUser)
    let isPortalAccess = currentOrg?.accessStatus === PORTAL_RESTRICTION?.ACCESS
    let isAllow = isPortalAccess || isSuperUser // we set all the module globally based on subscription and platform users
    const { getComponent = () => {} } = this.props
    if (loadedSuccessfully) {
      if (permissionsLoader) {
        return <Spin />
      } else {
        return getComponent({
          modifier: () => {
            return {
              permissions: permissions || {},
              isHaveGrantPermission: haveGrantPermission || false,
              isLoggingUserRoleId: isUser,
              isMediaCentricUser: !isCustomerUser,
              isSuperUser: isSuperUser,
              isCurrentOrg: currentOrg,
              isUsageLimit: usageLimit,
              isAllow: isAllow,
              planPermission: planPermission || {},
            }
          },
        })
      }
    } else {
      return (
        <div>
          Please clear your cookies or do hard refresh if it's not redirect you
          automatically.
        </div>
      )
    }
  }

  async componentDidMount() {
    const { getPermissions = () => {} } = this.props.permissionStore || {}
    let cToken = COOKIE_STOAGE.getItem('token')
    if (cToken) {
      let [result] = await getPermissions()
      this.setState({
        loadedSuccessfully: result,
      })
    } else {
      this.props.history.push(routes.login.generateRoute())
    }
  }
}

@inject('loginStore', 'permissionStore')
@observer
class RouteWrapper extends React.Component {
  permissionRoute = (routeSettings) => {
    return (
      <PermissionWrapper
        getComponent={(extra) => {
          return this.accessRoute(routeSettings, extra)
        }}
      ></PermissionWrapper>
    )
  }

  privateRoute = (routeSettings) => {
    const token = COOKIE_STOAGE.getItem('token')
    let isSuperUser = COOKIE_STOAGE.getItem('isSuperUser')
    isSuperUser = checkBoolean(isSuperUser)
    let organizationId = COOKIE_STOAGE.getItem('organizationId')
    organizationId = Boolean(organizationId)
    let isCompletedOnboard = COOKIE_STOAGE.getItem('isCompletedOnboard')

    let user = COOKIE_STOAGE.getItem('user')

    let areAccessible = isSuperUser || organizationId

    let { userMeta = [] } = user || {}

    userMeta = generateUserMetaIntoObject(userMeta)
    let isWizardNotCompleted =
      Number(isCompletedOnboard) !== ONBOARDING_WIZARD?.ON_COMPLETED &&
      userMeta?.roleId === ROLE_TYPE?.SUPER_ADMIN

    const {
      permission = true,
      permissionStore = {},
      loginStore = {},
    } = routeSettings
    const { isAfterLoginAlert = false, setCloseAfterLoginAlert = () => {} } =
      loginStore || {}

    const { currentOrg = {} } = permissionStore || {}
    const { afterLoginAlert = [] } = currentOrg || {}
    const isAfterLoginAlerts = afterLoginAlert?.length
    const { closeCount } = this.state || {}
    isAfterLoginAlerts == closeCount && setCloseAfterLoginAlert(false)
    if (token) {
      if (permission && areAccessible && !isWizardNotCompleted) {
        return [
          isAfterLoginAlert &&
            Boolean(isAfterLoginAlerts) &&
            this.afterLoginAlert(currentOrg, userMeta),
          this.permissionRoute(routeSettings),
        ]
      } else if (
        (permission && !areAccessible) ||
        (permission && isWizardNotCompleted)
      ) {
        const { history } = this.props
        if (isWizardNotCompleted) {
          history.replace(routes.termsConditionpage.generateRoute())
          return this.accessRoute(routes.termsConditionpage)
        }
        history.replace(routes.assignorg.generateRoute())
        return this.accessRoute(routes.assignorg)
      } else {
        return this.accessRoute(routeSettings)
      }
    } else {
      const { history } = this.props
      history.replace(routes.login.generateRoute())
      return this.accessRoute(routes.login)
    }
  }

  afterLoginAlert = (currentOrg, userMeta) => {
    const {
      afterLoginAlert = [],
      accessStatus = undefined,
      subscriptionStats = undefined,
    } = currentOrg || {}
    const { roleId } = userMeta || {}
    const { closeCount = 0 } = this.state || {}
    console.log(currentOrg)
    let haveToRenewPlan =
      subscriptionStats != SUBSCRIPTION_PLAN_STATUS?.ACTIVE &&
      roleId === ROLE_TYPE?.SUPER_ADMIN
    let navigateTo = haveToRenewPlan
      ? routes.subscriptionPlansList.generateRoute()
      : ''
    return (afterLoginAlert || []).map((alert, index) => {
      return (
        <SubscriptionAlertAfterLogin
          indexKey={index}
          visible={Boolean(alert)}
          bodyContent={alert}
          onSetClose={(value) => {
            this.setState({ closeCount: closeCount + 1 })
          }}
          toNavigate={navigateTo}
        />
      )
    })
  }

  accessRoute = (routeSettings, extra = {}) => {
    const { path, component, exact } = routeSettings || {}
    const { modifier } = extra
    return (
      <Route
        path={path}
        render={() => {
          let newProps = (modifier && modifier(component)) || {}
          let Component = component
          return <Component {...newProps}></Component>
        }}
        exact={exact}
      ></Route>
    )
  }

  render() {
    let isSuperUser = COOKIE_STOAGE.getItem('isSuperUser')
    isSuperUser = checkBoolean(isSuperUser)
    let organizationId = COOKIE_STOAGE.getItem('organizationId')
    organizationId = Boolean(organizationId)
    let isCompletedOnboard = COOKIE_STOAGE.getItem('isCompletedOnboard')
    let user = COOKIE_STOAGE.getItem('user')

    let areAccessible = isSuperUser || organizationId

    let { userMeta = [] } = user || {}
    userMeta = generateUserMetaIntoObject(userMeta)
    let isWizardNotCompleted =
      Number(isCompletedOnboard) !== ONBOARDING_WIZARD?.ON_COMPLETED &&
      userMeta?.roleId === ROLE_TYPE?.SUPER_ADMIN
    let privateRoute = this.props?.private
    let hybridRoute = this.props?.hybrid
    privateRoute = privateRoute === undefined ? true : privateRoute
    const token = COOKIE_STOAGE.getItem('token')
    const { pathName, loginStore } = this.props || {}
    if (privateRoute && !hybridRoute) {
      const currentUserId = this.props?.loginStore?.user?.id || undefined
      const currentCookieUserId =
        COOKIE_STOAGE?.getItem?.('user')?.id || undefined
      if (
        currentUserId &&
        currentCookieUserId &&
        currentCookieUserId !== currentUserId
      ) {
        window.location.reload()
        return <></>
      }
      return this.privateRoute(this.props)
    } else {
      if (pathName === routes.emailAcceptance.pathName) {
        // don not remove
        // confirm({
        //   title: TEXTS.DOCUMENT_DELETE,
        //   content: TEXTS.DELETE_WARNING,
        //   onOk: async () => {
        //     try {
        //       // await onDelete(id)
        //     } catch (err) {}
        //   },
        //   onCancel() {},
        // })
      } else if (pathName === routes.projectExportAll.pathName) {
      } else if (token && areAccessible && !hybridRoute) {
        const { history } = this.props
        history.replace(routes.homepage.generateRoute())
        return this.accessRoute(routes.homepage)
      } else if (hybridRoute) {
        if (
          (token && hybridRoute && !areAccessible) ||
          (token && hybridRoute && isWizardNotCompleted)
        ) {
          return this.accessRoute(this.props)
        } else {
          const { history } = this.props
          history.replace(routes.login.generateRoute())
          return this.accessRoute(routes.login)
        }
      }
      return this.accessRoute(this.props)
    }
  }
}

export default withRouter(RouteWrapper)
